import { createSelector } from "reselect";
import { createTable } from "robodux";
import { put } from "saga-query";

import { thunks } from "../apis/api";

// import { selectCurrentEmail } from './ui/usertree';

import type { IAdminGroupUser } from "@app/types";
import type { RootState } from "@app/state/rootState";

const REPO_USERS_AVAILABLE = "users/all-avaliable";

export const usersRepo = createTable<IAdminGroupUser>({
  name: REPO_USERS_AVAILABLE,
  initialState: {},
});

export const setUsersData = thunks.create<
  Record<IAdminGroupUser["GROUPID_EMAIL"], IAdminGroupUser>
>("users/set/all-avaialble", function* (ctx, next) {
  yield* put(usersRepo.actions.set(ctx.payload));
  yield* next();
});

export const resetUsersData = thunks.create(
  "users/reset/all-avaialble",
  function* (ctx, next) {
    yield* put(usersRepo.actions.reset());
    yield* next();
  }
);

export const patchUsersData = thunks.create<
  Record<IAdminGroupUser["GROUPID_EMAIL"], IAdminGroupUser>
>("users/patch/all-avaialble", function* (ctx, next) {
  yield* put(usersRepo.actions.patch(ctx.payload));
  yield* next();
});

export const addNewUserMember = thunks.create<
  Record<IAdminGroupUser["GROUPID_EMAIL"], IAdminGroupUser>
>("users/add/one-user-on-group", function* (ctx, next) {
  yield* put(usersRepo.actions.add(ctx.payload));
  yield* next();
});

function createParameterSelector(selector: any) {
  return (_: unknown, params: any) => selector(params);
}

const selectByGroupId = createParameterSelector(
  ({ GROUPID }: { GROUPID: number }) => GROUPID || null
);
const selectByUserEmail = createParameterSelector(
  ({ EMAIL }: { EMAIL: string }) => EMAIL || null
);

const selectByCompositeKey = createParameterSelector(
  ({ GROUPID_EMAIL }: { GROUPID_EMAIL: string }) => GROUPID_EMAIL || null
);

const selectors = usersRepo.getSelectors(
  (state: RootState) => state[REPO_USERS_AVAILABLE]
);
type TAdminUserRed = Record<IAdminGroupUser["GROUPID_EMAIL"], IAdminGroupUser>;

const splitOUserRigts = (dbur: string): string[] => {
  const jgaprigths = dbur
    .split("-")
    .filter((r) => r === r && !r.trim().startsWith("#"))
    .join("-");
  const insider = dbur
    .split("-")
    .filter((r) => r === r && r.trim().startsWith("#"))
    .join("-");
  return [`-${jgaprigths}-`, `-${insider}-`];
};

export const selectAllUsersList = createSelector(selectors.selectTable, (t) => {
  return Object.entries(t).reduce((acc: TAdminUserRed, [key, value]) => {
    if (!value) return acc;
    const _key = key as IAdminGroupUser["GROUPID_EMAIL"];
    acc[_key] = {
      ...value,
      _OUSER_RIGHTS_JGAP: splitOUserRigts(value.OUSER_RIGHTS || "")[0],
      _OUSER_RIGHTS_INSIDER: splitOUserRigts(value.OUSER_RIGHTS || "")[1],
      _roles: [],
      _verified: false,
    };
    return acc;
  }, {});
});

// export const selectHomeDataOfSelectedUser = createSelector(
//   selectCurrentEmail,
//   selectors.selectTable,
//   (email, t) => t?.[`~/${email}`] || {} as IAdminGroupUser
// );

export const selectHomeDataOfSelectedUser = (state: RootState, email: string) =>
  selectors.selectById(state, { id: `~/${email}` }) || ({} as IAdminGroupUser);

export const selectGroupDataOfSelectedUser = createSelector(
  selectByCompositeKey,
  selectors.selectTable,
  (email, t): IAdminGroupUser => {
    console.log("t", t);
    console.log("email", email);
    return t[email] || ({} as IAdminGroupUser);
  }
);
/* 
/login --> my login with my groups [group ids ]
/ groups/all-avaliable --> all groups 
/ users/all-avaliable --> all users

/admin [groupinfo, users, licence stuff] -> the groups I admin
/swsadmin -> assign admins to groups. , create groups so on
*/

// export const selectAllUserGroups = createSelector(
//   selectors.selectTable,
//   selectCurrentEmail,
//   (t, email) => {
//     const data = Object.values(t).filter((u) => u && u.OUSER_EMAIL === email);
//     return data;
//   }
// );
